import React, { useState } from "react";
import { Grid, Button} from '@material-ui/core';
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useForm } from "../../../../hooks/useForm";
import { FormPrestExternosPracticas } from "./FormPrestExternosPracticas";
import { FormVerPrestExternosPracticas } from "./FormVerPrestExternosPracticas";
import ModalAbm from "../../../compartidos/abms/ModalAbm";

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormModifPrestadoresRestringidos = (props) => {

    const classes = useStyles();
    const { formData, permisoEdit, permisoAlta } = props;
    const { permisos: permisosUser } = useSelector(state => state.auth);

    const [openModalAltaPractica, setOpenModalAltaPractica] = useState(false);

    const [openModalVerPractica, setOpenModalVerPractica] = useState(false);


    const formInit = {
        descripcion: ""
    }

    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues);
    };

    const handleSavePractica = (e) => {
        e.preventDefault()
        // console.log("efector", value)
        // props.handleSave(formValues, value);
    };

    const [formValues, handleInputChange] = useForm(formData ? formData : formInit);


    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Razon Social"
                        name="razonSocial"
                        value={formValues.razonSocial}
                        autoComplete="off"
                        disabled={true}
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["La descripción es requerida"]}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Id efector"
                        name="idEfectorFacturacion"
                        value={formValues.idEfectorFacturacion}
                        disabled={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["La descripción es requerida"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Observacion"
                        name="observaciones"
                        value={formValues.observaciones}
                        disabled={false}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["La descripción es requerida"]}
                    />
                </Grid>
                <Grid container className={classes.botonera}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Grid item xs={6}>
                                <ModalAbm title="Agregar Practicas" open={openModalAltaPractica} setOpen={setOpenModalAltaPractica}>
                                    <FormPrestExternosPracticas idEfectorFacturacion={formValues.idEfectorFacturacion} handleSavePractica={handleSavePractica} handleCloseModal={() => setOpenModalAltaPractica(false)} />
                                </ModalAbm>
                                <Button variant="contained" color="primary" onClick={() => setOpenModalAltaPractica(true)} style={{ float: "left", marginTop: "0.0rem", marginLeft: "-4rem" }}>+ Agregar Prácticas</Button>
                                <ModalAbm title="Ver Practicas" open={openModalVerPractica} setOpen={setOpenModalVerPractica}>
                                    <FormVerPrestExternosPracticas idEfectorFacturacion={formValues.idEfectorFacturacion} handleSavePractica={handleSavePractica} handleCloseModal={() => setOpenModalVerPractica(false)} />
                                </ModalAbm>
                                <Button variant="contained" color="primary" onClick={() => setOpenModalVerPractica(true)} style={{ float: "left", marginTop: "0.0rem", marginLeft: "1rem" }}>Ver Prácticas</Button>
                            </Grid>

                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            {(validarSoloUnPermiso(permisosUser, permisoAlta) ||
                                validarSoloUnPermiso(permisosUser, permisoEdit)) && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<SaveIcon />}
                                        type="submit"
                                        style={{ marginLeft: "0.5rem" }}
                                    >
                                        GUARDAR
                                    </Button>
                                )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
